
import colors from 'tailwindcss/colors'
import LongArrowLeft from '@/assets/icons/fontawesome/light/long-arrow-left.svg?inline'
import LongArrowRight from '@/assets/icons/fontawesome/light/long-arrow-right.svg?inline'

export default {
  components: {
    LongArrowLeft,
    LongArrowRight,
  },
  props: {
    hotel: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    toHotel: {},
    modalMap: false,
    type: null,
    icon: {},
  }),
  methods: {
    setMarker(item) {
      this.toHotel = item
      this.icon = {
        path: 0,
        fillColor: item.types.includes('tourist_attraction')
          ? colors.green[700]
          : item.types.includes('restaurant')
          ? colors.blue[700]
          : colors.yellow[300],
        fillOpacity: 1,
        strokeColor: '#ffffff',
        strokeWeight: 2,
        strokeOpacity: 0,
        scale: 10,
      }
    },
    openMap() {
      this.$emit('openMap')
    },
  },
}
